// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app__logo-loader{display:flex;height:100%;align-items:center;justify-content:center;margin-top:-30px}", ""]);
// Exports
module.exports = exports;
